var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"center mx-auto my-auto landing"},[(_vm.showBubble)?_c('b-button',{staticClass:"button_image",style:(_vm.bubbleStyle),attrs:{"variant":"success"},on:{"click":_vm.showHome}}):_vm._e()],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }